import { Person } from "../person/Person"

export class Landplot {
    id: number
    polygon: {
        coordinates: any
    }
    name: string
    pickup_position: any
    externalId: string
    size?: number
    isPlotInProgram?: boolean
    owner?: Person

    constructor(p: any) {
        this.id = p.id
        this.polygon = p.polygon
        this.name = p.name
        this.pickup_position = p.pickup_position
        this.externalId = p.externalId
        this.size = p.size
        this.isPlotInProgram = p.isPlotInProgram
        if (p.owner) {
            this.owner = Person.build(p.owner)
        } else if (p.owner_organisation_id) {
            this.owner = Person.build({
                id: 0,
                firstname: p.owner_firstname,
                lastname: p.owner_lastname,
                location: p.location,
                user: {
                    avatar_url: p.owner_avatar_url
                },
                transactor: {
                    id: p.owner_transactor_id
                }
            })
        }
    }

    static build(plot: any): Landplot {
        return new Landplot(plot)
    }
}